// Fullstory Analytics Service using V2 SDK
import { FullStory, init, isInitialized } from '@fullstory/browser';

let fullstoryInitialized = false;

const FULLSTORY_ORG_ID = window.env?.REACT_APP_FULLSTORY_ORG_ID;
const FULLSTORY_ENABLED = window.env?.REACT_APP_FULLSTORY_ENABLED === 'true' || window.env?.REACT_APP_FULLSTORY_ENABLED === true;
const FULLSTORY_DEBUG = window.env?.REACT_APP_FULLSTORY_DEBUG === 'true' || window.env?.REACT_APP_FULLSTORY_DEBUG === true;
const FULLSTORY_DEVMODE = window.env?.REACT_APP_FULLSTORY_DEVMODE === 'true' || window.env?.REACT_APP_FULLSTORY_DEVMODE === true;

export const initFullstory = () => {
  if (!FULLSTORY_ENABLED) {
    console.warn('Fullstory is disabled in this environment.');
    return;
  }

  if (fullstoryInitialized || isInitialized()) {
    console.warn('Fullstory is already initialized.');
    return;
  }

  if (typeof window === 'undefined') {
    console.warn('Fullstory cannot be initialized on server side.');
    return;
  }

  try {
    init({
      orgId: FULLSTORY_ORG_ID,
      debug: FULLSTORY_DEBUG,
      devMode: FULLSTORY_DEVMODE,
    });

    fullstoryInitialized = true;
    console.debug('Fullstory V2 SDK initialized successfully with org ID:', FULLSTORY_ORG_ID);
  } catch (error) {
    console.error('Error initializing Fullstory V2 SDK:', error);
  }
};

export const identifyUser = (userId, userVars = {}) => {
  if (!fullstoryInitialized && !isInitialized()) {
    console.warn('Fullstory not initialized');
    return;
  }

  try {
    if (userId) {
        FullStory('setIdentity', { uid: userId, ...userVars });
        console.debug('User identified in Fullstory:', userId);
    }
  } catch (error) {
    console.error('Error identifying user in Fullstory:', error);
  }
};

const fullstoryService = {
  initFullstory,
  identifyUser
};

export default fullstoryService;
